import React, { useState, useContext, useEffect } from "react";
import { GlobalContext } from "../context/GlobalContext";
import { listIndexing } from "../helper/api-indexing";

export default function   Indexing(props) {
  const { settings } = useContext(GlobalContext);
  const [indexing, setIndexing] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state if needed

  useEffect(() => {
    document.title = "Indexing | " + settings.websitename;
    const abortController = new AbortController();
    const signal = abortController.signal;

    setLoading(true); // Set loading state when starting the fetch

    listIndexing(signal)
      .then((data) => {
        if (data && data.error) {
          console.error(data.error);
        } else {
          setIndexing(
            data
              .filter((index) => index.status === "enabled")
              .sort((a, b) => a.sortnumber - b.sortnumber)
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching indexing data:", error);
        // Handle errors here, e.g., setIndexing([]);
      })
      .finally(() => {
        setLoading(false); // Reset loading state regardless of success or failure
      });

    return function cleanup() {
      // Ensure signal is only aborted if it's not already aborted
      if (!signal.aborted) {
        abortController.abort();
      }
    };
  }, [settings]);

  return (
    <div className="grid grid-cols-2">
      {loading ? (
        <p>Loading...</p> // Optional: Show loading indicator
      ) : (
        indexing.map((indexItem, index) => (
          <a
            key={`indexing-${index + 1}`}
            className="flex items-center justify-center p-7 indexing-element"
            href={indexItem.link}
            style={{ pointerEvents: indexItem.link ? "auto" : "none" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={`assets/indexing/${indexItem.image}`}
              className="w-full h-auto -webkit-optimize-contrast"
              alt={indexItem.title}
            />
          </a>
        ))
      )}
    </div>
  );
}
